export const EgresadoDisclaimer = ({ testid = "egresado-disclaimer", className = "mb-4" }) => (
  <div className={`${className} rounded-xl border-2 border-[var(--brand-accent)] bg-[var(--brand-surface)] px-4 py-3`} data-testid={testid}>
    <p className="text-xs text-[var(--brand-primary)] font-semibold">Portal exclusivo para egresados/as de Córdoba Crea Futuro.</p>
    <p className="text-xs text-[var(--brand-text-muted)] mt-1">Registrate solo si completaste o estás cursando una formación de CCF.</p>
  </div>
);
